import React from "react";
import { useSettings } from "../context/SettingsContext";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { useToast } from "../hooks/use-toast";

export default function InfoPage({ type }) {
  const { settings } = useSettings();
  const { toast } = useToast();

  const onContact = (e) => {
    e.preventDefault();
    const name = e.target.elements.name.value;
    const message = e.target.elements.message.value;
    const text = encodeURIComponent(`היי, שמי ${name}.\n${message}`);
    window.open(`https://wa.me/${settings.whatsapp}?text=${text}`, "_blank");
    toast({ title: "Opening WhatsApp", description: "We'll get back to you shortly." });
  };

  if (type === "about") {
    return (
      <div className="fade-up mx-auto max-w-3xl px-4 md:px-8 py-20">
        <p className="text-xs tracking-[0.3em] text-neutral-400 text-center">{settings.brandName}</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-wide text-center mt-3">ABOUT US</h1>
        <div className="mt-10 space-y-5 text-neutral-600 leading-relaxed text-center">
          <p>
            {settings.brandName} is a contemporary fashion label built on the belief that
            elegance lives in the details. Each piece is designed to be timeless,
            versatile and effortlessly feminine.
          </p>
          <p>
            From tailored tweed sets to relaxed everyday essentials, our collections
            are crafted with care and made to be loved season after season.
          </p>
          <p>אופנה שמרגישים בה טוב — בכל יום מחדש.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-up mx-auto max-w-5xl px-4 md:px-8 py-20">
      <p className="text-xs tracking-[0.3em] text-neutral-400 text-center">GET IN TOUCH</p>
      <h1 className="font-display text-4xl md:text-5xl tracking-wide text-center mt-3">CONTACT</h1>

      <div className="mt-12 grid gap-12 md:grid-cols-2">
        <div className="space-y-6">
          <p className="text-neutral-600 leading-relaxed">
            Questions about an order, sizing or styling? Reach out — we love hearing from you.
          </p>
          <ul className="space-y-4 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-5 w-5 text-neutral-700" />
              <a href={`tel:${settings.whatsapp}`} className="hover:text-black">{settings.whatsappDisplay}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-neutral-700" />
              <a href={`mailto:${settings.email}`} className="hover:text-black">{settings.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="h-5 w-5 text-neutral-700" />
              <a href={settings.instagram} target="_blank" rel="noreferrer" className="hover:text-black">@{settings.brandName.toLowerCase()}</a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-5 w-5 text-neutral-700" />
              <span className="text-neutral-600">Israel</span>
            </li>
          </ul>
        </div>

        <form onSubmit={onContact} className="space-y-4">
          <input name="name" required placeholder="Your name" className="w-full border border-neutral-300 px-4 py-3 text-sm outline-none focus:border-black transition-colors" />
          <textarea name="message" required rows={5} placeholder="Your message" className="w-full border border-neutral-300 px-4 py-3 text-sm outline-none focus:border-black transition-colors resize-none" />
          <button type="submit" className="w-full bg-black text-white py-3.5 text-xs tracking-[0.2em] hover:bg-neutral-800 transition-colors">
            SEND VIA WHATSAPP
          </button>
        </form>
      </div>
    </div>
  );
}
